<template>
  <Modal
    :show="show.updateFromTemplateConfirm"
    action-text="Update"
    @close="close"
    @action="confirm"
  >
    <template #title>
      Update from template
    </template>

    <template #content>
      <div>
        The locked fields of this profile will be updated with the latest content from
        <strong>{{ appliedTemplate?.title }}</strong> template.
      </div>
      <div>
        Title and job code will not be updated.
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useJobProfiles } from '@/stores/jobProfiles/jobProfiles';
import Modal from '@/components/shared/Modal.vue';

const { show } = storeToRefs(useModals());
const { setModal } = useModals();

const { jobProfile } = storeToRefs(useCurrentJobProfile());
const { finalizedTemplates } = storeToRefs(useJobProfiles());

const appliedTemplate = computed(() => finalizedTemplates.value.find(
  (t) => t.ulid === jobProfile.value?.last_applied_template_ulid,
));

const close = () => setModal({ field: 'updateFromTemplateConfirm', value: false });

const confirm = async () => {
  await useCurrentJobProfile().applyTemplate({
    templateUlid: jobProfile.value?.last_applied_template_ulid,
  });
  await useCurrentJobProfile().loadJobProfile({ ulid: jobProfile.value?.ulid });
  setModal({ field: 'jobProfileCompare', value: false });
  close();
};
</script>
